export const COMPONENT_SIGNAL_PREVIEW_LIMIT = 180;
